module.exports = __webpack_public_path__ + "img/Right.03edc4bc.svg";